var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerAcquisition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-934 516 50 50",
    style: {
      enableBackground: "new -934 516 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#00DC86;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#000;}\n\t.st2{fill:#000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-922,532.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-909,547c-3.2,0-6.2-1.2-8.5-3.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0c1.7,1.7,4,2.6,6.4,2.6     c2.4,0,4.7-0.9,6.4-2.6c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1C-902.8,545.8-905.8,547-909,547z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -903.9,
    cy: 534,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -914.1,
    cy: 534,
    r: 1.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-909,522.4c8.1,0,14.6,6.5,14.6,14.6c0,8.1-6.5,14.6-14.6,14.6s-14.6-6.5-14.6-14.6    C-923.6,529-917.1,522.4-909,522.4 M-909,519.4c-9.7,0-17.6,7.9-17.6,17.6c0,9.7,7.9,17.6,17.6,17.6s17.6-7.9,17.6-17.6    C-891.4,527.3-899.3,519.4-909,519.4L-909,519.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-919.9,555.3c-6,1.8-10.7,5.1-13.2,9.3c0,0,3.7,0,3.7,0c3-3.6,8.4-6.4,14.8-7.4    C-916.4,556.8-918.2,556.2-919.9,555.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-887.9,547.8c-0.2,0-0.4,0-0.6-0.1c-0.8-0.3-1.1-1.2-0.8-2c1.1-2.6,1.7-5.4,1.7-8.3c0-2.9-0.6-5.7-1.7-8.3    c-0.3-0.8,0-1.6,0.8-2c0.8-0.3,1.6,0,2,0.8c1.3,3,1.9,6.2,1.9,9.5c0,3.3-0.6,6.5-1.9,9.5C-886.7,547.4-887.3,547.8-887.9,547.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-930.1,547.8c-0.6,0-1.1-0.3-1.4-0.9c-1.3-3-1.9-6.2-1.9-9.5c0-3.3,0.6-6.5,1.9-9.5c0.3-0.8,1.2-1.1,2-0.8    c0.8,0.3,1.1,1.2,0.8,2c-1.1,2.6-1.7,5.4-1.7,8.3c0,2.9,0.6,5.7,1.7,8.3c0.3,0.8,0,1.6-0.8,2    C-929.7,547.7-929.9,547.8-930.1,547.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-898.3,555.3c6,1.8,10.7,5.1,13.2,9.3c0,0-3.7,0-3.7,0c-3-3.6-8.4-6.4-14.8-7.4    C-901.7,556.8-900,556.2-898.3,555.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAcquisition);
export default __webpack_public_path__ + "static/media/customer-acquisition.6dde1e6c284d0e6f57c499ab75834f78.svg";
export { ForwardRef as ReactComponent };